export const formatKycRuleType = (type: string): string => {
  const label = type.trim().replace(/_+/g, " ").replace(/\s+/g, " ").toLowerCase();
  return label.charAt(0).toUpperCase() + label.slice(1);
};
